/**
 * BID LMS V3 - Admin Dashboard
 *
 * Phase 2: Routed admin UI with shallow functionality.
 * Uses Operational Architect design tokens for professional admin workflows.
 */

import { Outlet } from 'react-router';
import { AdminShell } from './components/AdminShell';

function App() {
  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  );
}

export default App;
